const ImageModel = {
  fetchSignedUrl: async (imageKey, forceRefresh = false) => {
    let apiUrl =
      process.env.NODE_ENV === "development"
        ? `/api/GenerateSignedURL?imageKey=images/${imageKey}.jpg`
        : `https://5w6fa6obpl.execute-api.eu-north-1.amazonaws.com/prod/GenerateSignedURL?imageKey=images/${imageKey}.jpg`;

    // Cache-Busting: If this is a self-healing retry, append a random timestamp
    // so Chrome is physically forced to bypass its disk cache and actually ask AWS.
    if (forceRefresh) {
      apiUrl += `&retry=${Date.now()}`;
    }

    // Explicitly tell the browser to cache this fetch request locally
    const response = await fetch(apiUrl, { cache: forceRefresh ? "no-store" : "force-cache" });
    const { url } = await response.json();
    return url;
  },
};

export default ImageModel;
